import * as React from "react";
const VesselReportsView = React.lazy(() => import("./VesselReportsViewContainer"));

export { VesselReportsView };
